import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=c4891904&scoped=true"
import script from "./Levels.vue?vue&type=script&lang=js"
export * from "./Levels.vue?vue&type=script&lang=js"
import style0 from "./Levels.vue?vue&type=style&index=0&id=c4891904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4891904",
  null
  
)

export default component.exports